import React, { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faChevronDown, faChevronUp, faSortUp, faSortDown, faX, faPaperclip, faPlus, faPen, faMobileAndroidAlt, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import  '../Css/Tooltip.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { Spinner, Loader } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import useAutoScroll from '../Components/UseAutoScroll';
import { decryptData } from '../../utils/storageCrypto';
// import { set } from 'react-datepicker/dist/date_utils';


// Custom hook to handle outside clicks
const useOutsideClick = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
};

const CustomDropdown = ({ options, selected, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => setIsOpen(false));
  const handleOptionClick = (value) => {
    onSelect(value);
    setIsOpen(false);
  };



  return (

    <div className="relative w-1/6" ref={dropdownRef}>

    <div

      className="flex justify-between items-center p-2 border bg-white border-gray-300 rounded-md cursor-pointer"

      onClick={() => setIsOpen(!isOpen)}

    >

      <span className={`text-sm ${selected ? 'text-black' : 'text-[#838195]'}`}>

        {selected || 'Salu'}

      </span>

      <FontAwesomeIcon icon={faChevronDown} className="w-3 h-3 text-gray-500" />

    </div>

    {isOpen && (

      <div className="absolute mt-1 w-full h-40 bg-white border border-gray-300 rounded-md shadow-lg z-10 flex flex-col">

        <div className="overflow-y-auto scrollbar-visible flex-grow">

          {options.map((option) => (

            option.value !== 'add-new' && (

              <div className='p-1'>

              <div

                key={option.value}

                className="py-2 pl-1 cursor-pointer text-sm hover:bg-blue-500 hover:rounded-md  hover:text-white"

                onClick={() => handleOptionClick(option.value)}

              >

                {option.icon && <FontAwesomeIcon icon={option.icon} className="" />}

                {option.label}

              </div>

              </div>

            )

          ))}

        </div>

      </div>

    )}

  </div>

  

  );
};

const ViewProductCategory = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {ProductCategoryData}= location.state || {}
  const [productCategories, setProductCategories] = useState([  ]);
  const [productSubcategories, setProductSubcategories] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [selectedProductCategory, setSelectedProductcategory] = useState();
  const [productcategoryid , setproductcategoryid] = useState(null);
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const url = process.env.REACT_APP_FORE_BRICKBUCKET
  const [errorMessages, setErrorMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [ProductCategoryLoader, setProductCategoryLoader] = useState(true)
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [retryFunction, setRetryFunction] = useState(null);
  const [roleId, setRoleId] = useState(null);
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES
  const [allUOMs, setAllUOMs] = useState([]);
 const itemRefs = useRef({});
   const listContainerRef = useRef(null);
   const [assignType, setAssignType] = useState(null);
const assignDropdownRef = useRef(null);
const [showAssignPopup, setShowAssignPopup] = useState(false);
const [showAssignAttributesPopup, setShowAssignAttributesPopup] = useState(false);
const [productAttributes, setAttributes] = useState([]);
const [attributeLoading, setAttributeLoading] = useState(false);
const [errors, setErrors] = useState({});
const [attributeIds, setAttributeIds] = useState([]);
const [isSaving, setIsSaving] = useState(false);
const [selectedSubcategory, setSelectedSubcategory] = useState(null);
const [showAssignCategoryAttributesPopup, setShowAssignCategoryAttributesPopup] = useState(false);
const [categoryAttributes, setCategoryAttributes] = useState([]);
const [subcategoryAttributes, setSubcategoryAttributes] = useState([]);
const [showFaqPopup, setShowFaqPopup] = useState(false);
const [categoryFaqs, setCategoryFaqs] = useState([]);
const [subcategoryFaqs, setSubcategoryFaqs] = useState([]);
const [selectedFaqSubcategory, setSelectedFaqSubcategory] = useState(null);
const [selectedCategoryFaqIds, setSelectedCategoryFaqIds] = useState([]);
const [newFaqQuestion, setNewFaqQuestion] = useState('');
const [newFaqAnswer, setNewFaqAnswer] = useState('');
const [faqLoading, setFaqLoading] = useState(false);
const [faqError, setFaqError] = useState('');
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
const [faqToDelete, setFaqToDelete] = useState(null);
const categoryName = selectedProductCategory?.product_category_name || "Selected Category";
const categoryImage = selectedProductCategory?.product_category_image;
const [loadingFaqId, setLoadingFaqId] = useState(null); // 👈 NEW: track which FAQ is loading

  useEffect(() => {
    fetchRoleId();
    fetchProductCategories(ProductCategoryData);
  }, [ProductCategoryData?._id]);

  useAutoScroll({
  selectedItem: selectedProductCategory,
  itemRefs,
  containerRef: listContainerRef,
});



useEffect(() => {
  function handleClickOutside(event) {
    if (
      assignDropdownRef.current &&
      !assignDropdownRef.current.contains(event.target) &&
      !showAssignAttributesPopup // ✅ important condition
    ) {
      setAssignType(null);
    }
  }

  if (assignType && !showAssignAttributesPopup) {
    document.addEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [assignType, showAssignAttributesPopup]);


const handleOpenAssign = () => {
  setAssignType(!assignType);
};

const handleAssignTypeSelect = (type) => {
  setAssignType(type);
  if (type === "attributes") {
    console.log("Already assigned attribute_value_ids:",
      selectedProductCategory?.attribute_value_ids
    );

    fetchProductCategoryAttributes(selectedProductCategory?._id);
    setShowAssignCategoryAttributesPopup(true);
  }
};



  const fetchRoleId = () => {
    const encryptedroleId = sessionStorage.getItem('roleId');
    const sroleId = decryptData(encryptedroleId)
    setRoleId(sroleId);
  };
  const fetchAllUOMs = async () => {
        const encryptedToken = sessionStorage.getItem('token');
        const token = decryptData(encryptedToken);

    const response = await fetch(`${backendApiUrl}UOMs/get-all-UOMs`, {
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
    const data = await response.json();
    if (data.status === 200 || data.status === 201) {
      setAllUOMs(data.data);
    }
    console.log(data);
  };
  useEffect(() => {
    fetchAllUOMs();
  }, []);
  

  const fetchProductCategories = async (CategoryData,attempt = 1) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const response = await fetch(`${backendApiUrl}product-category/get-all-productCategories`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
    });
    
    const data = await response.json();
    const output = await getResponseHandling(response, data);
    console.log('📦 Categories loaded:', output);
    
    if (output) {
      setProductCategories(output);
      
      if (ProductCategoryData?._id) {
        const matchingCategory = output.find(cat => cat._id === ProductCategoryData._id);
        if (matchingCategory) {
          handleProductCategoryClick(matchingCategory);
        } else if (output.length > 0) {
          handleProductCategoryClick(output[0]);
        }
      } else if (output.length > 0) {
        handleProductCategoryClick(output[0]);
      }
    } else {
      setProductCategories([]);
      console.log('❌ No categories found');
    } 
  } catch (error) {
    console.error('❌ Failed to fetch categories:', error);

    if (attempt < RETRY_LIMIT) {
      console.log(`🔄 Retry attempt ${attempt + 1}/${RETRY_LIMIT}`);
      setRetryCount(attempt + 1);
      setTimeout(() => fetchProductCategories(CategoryData, attempt + 1), 1000);
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => fetchProductCategories(CategoryData, attempt));
    }
  } finally {
    setIsLoading(false);
  }
};
 

  const fetchProductSubcategoriesByProductCategoryId = async (productCategoryId,attempt = 1) => {
    console.log('Product Category ID:', productCategoryId); // Add this line to verify ID
    try {
          const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);

      const response = await fetch(`${backendApiUrl}product-category/get-all-subcategories-and-UOMs-under-product-category?product_category_id=${productCategoryId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      });
      const data = await response.json();
      const output =  await getResponseHandling(response , data)
      console.log(output)
      if (output) {
        setProductSubcategories(output?.subCategories || []);
      } else {
        setProductSubcategories([]);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchProductSubcategoriesByProductCategoryId(productCategoryId,attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchProductSubcategoriesByProductCategoryId(productCategoryId,attempt)); // Set retry function
      }
    }finally{
       setProductCategoryLoader(false) 
    }
  };

  const getResponseHandling = async (response, data)=>{
      if (response.status === 200 || response.status === 201) {
        setPopupType('200or201');
          return (data.data)
      } else if (response.status === 204) {
        setPopupType('204');
        return (data.data)
      } 
   
      if (response.status === 400) {
        setPopupType('400');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 401) {
        setPopupType('401');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 403) {
       
        setPopupType('403');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 500) {
       
        setPopupType('500');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else {
        setErrorMessages([...errorMessages, data.message]);
      }
    
  }

  const handleProductCategoryClick = (productcategory) => {
    setproductcategoryid(productcategory._id);
    setSelectedProductcategory(productcategory);
    fetchProductSubcategoriesByProductCategoryId(productcategory._id);
   
  };

  const handleCreateProductCategory = () => {
    navigate('/bb/app/items/newproductcategory')
  }
  
  const handleClose = () => {
    navigate('/bb/app/items/productcategories');
  }

  const closePopup = () => {
    console.log("closePopup called");
    setShowPopup(false);
  };
  
  const Retry = async() => {
    console.log("Retry called");
    setTimeout(async ()=>{
      if(retryFunction){

        await retryFunction ();
      }

      setIsLoading(false)
    },1000)
    
    setShowPopup(false);
  };

  const fetchProductCategoryAttributes = async (categoryId) => {
  try {
    setAttributeLoading(true);

    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    const response = await fetch(
      `${backendApiUrl}product-attributes/get-all-attributes-by-productCategory?product_category_id=${categoryId}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const data = await response.json();

    console.log("API attributes response:", data);

    if (data.status === 200) {

      const attributes = data.data || [];

      console.log("Category Attributes:", attributes);

      setCategoryAttributes(attributes);

      if (selectedProductCategory?.attribute_value_ids) {

        console.log("Assigned IDs from category:",
          selectedProductCategory.attribute_value_ids
        );

        const assigned = [];

        attributes.forEach(attr => {

          console.log("Checking attribute:", attr.attribute_name);

          attr.attribute_values.forEach(val => {

            console.log("Checking value:", val.attribute_value_id);

            if (
              selectedProductCategory.attribute_value_ids.includes(
                val.attribute_value_id
              )
            ) {

              console.log("MATCH FOUND:", val.attribute_value_id);

              assigned.push({
                attribute_name_id: attr.attribute_name_id,
                attribute_value_id: val.attribute_value_id
              });

            }

          });

        });

        console.log("Final assigned attributes:", assigned);

        setAttributeIds(assigned);
      }

    } else {
      setCategoryAttributes([]);
    }

  } catch (error) {
    console.error("Error fetching attributes:", error);
  } finally {
    setAttributeLoading(false);
  }
};


const fetchAllAttributesBySubcategory = async (categoryId, subcategoryId) => {
  try {
    setAttributeLoading(true);

    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    const response = await fetch(
      `${backendApiUrl}product-attributes/get-attr-upward?product_category_id=${categoryId}&product_sub_category_id=${subcategoryId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const data = await response.json();

    if (data.status === 200) {
      let attributes = data.data || [];
      
      // 🎯 STABLE SORTING (A→Z) - Prevents reordering forever
      attributes.sort((a, b) => a.attribute_name.localeCompare(b.attribute_name));
      
      // 🎯 Sort values within each attribute consistently
      attributes.forEach(attr => {
        if (attr.attribute_values) {
          attr.attribute_values.sort((a, b) => 
            a.attribute_value.localeCompare(b.attribute_value)
          );
        }
      });
      
      setSubcategoryAttributes(attributes);
    } else {
      setSubcategoryAttributes([]);
    }
  } catch (error) {
    console.error("Error fetching attributes:", error);
    setSubcategoryAttributes([]);
  } finally {
    setAttributeLoading(false);
  }
};

  

const handleCloseAttributePopup = () => {
  setShowAssignAttributesPopup(false);
  setAttributeIds([]);
  setErrors({});
};

const handleCloseCategoryAttributePopup = () => {
  setShowAssignCategoryAttributesPopup(false);
  setAttributeIds([]);
  setErrors({});
};


const handleCheckboxChange = (attribute_name_id, attribute_value_id) => {

  setAttributeIds((prev) => {

    const exists = prev.find(
      (attr) => attr.attribute_value_id === attribute_value_id
    );

    if (exists) {
      return prev.filter(
        (attr) => attr.attribute_value_id !== attribute_value_id
      );
    }

    // add new
    return [
      ...prev,
      {
        attribute_name_id,
        attribute_value_id,
      },
    ];
  });
};


const handleCheckboxChangeCategory = (attribute_name_id, attribute_value_id) => {

  setAttributeIds((prev) => {

    const exists = prev.find(
      (attr) => attr.attribute_value_id === attribute_value_id
    );

    if (exists) {
      // remove if unchecked
      return prev.filter(
        (attr) => attr.attribute_value_id !== attribute_value_id
      );
    }

    // add new checkbox
    return [
      ...prev,
      {
        attribute_name_id,
        attribute_value_id,
      },
    ];
  });

};



const handleAddattributesToSubCategory = async () => {

  if (attributeIds.length === 0) {
    setErrors({ assign_attribute: "Please select attribute values" });
    return;
  }

  try {
    setIsSaving(true);

    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    // ✅ Convert objects → only attribute_value_id array
    const attributeValueIds = attributeIds.map(attr => attr.attribute_value_id);

    const response = await fetch(
      `${backendApiUrl}product-sub-category/assign-attributes-to-productSubCategory`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({
          product_sub_category_id: selectedSubcategory._id,
          attribute_value_ids: attributeValueIds
        }),
      }
    );

    const data = await response.json();
    console.log("Assign attributes response:", data);

  if (data.status === 200 || data.status === 201) {

  console.log("Updated subcategory:", data.data);

  // ⭐ Update subcategory list state
  setProductSubcategories(prev =>
    prev.map(sub =>
      sub._id === data.data._id
        ? { ...sub, attribute_value_ids: data.data.attribute_value_ids }
        : sub
    )
  );

  setPopupType('200or201');
  setPopupMessage('Attributes assigned to SubCategory successfully');
  setShowPopup(true);

  setShowAssignAttributesPopup(false);
  setAttributeIds([]);
  setErrors({});

  setTimeout(() => {
    setShowPopup(false);
  }, 3000);
}

  } catch (error) {
    console.error("Error assigning attributes:", error);
  } finally {
    setIsSaving(false);
  }
};

const handleAddattributesToCategory = async () => {

  if (attributeIds.length === 0) {
    setErrors({ assign_attribute: "Please select attribute values" });
    return;
  }

  try {
    setIsSaving(true);

    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    // ✅ convert objects to only attribute_value_id array
    const attributeValueIds = attributeIds.map(
      (attr) => attr.attribute_value_id
    );

    const response = await fetch(
      `${backendApiUrl}product-category/assign-attributes-to-productCategory`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify({
          product_category_id: selectedProductCategory._id,
          attribute_value_ids: attributeValueIds
        }),
      }
    );

    const data = await response.json();
    console.log("Assign attributes response:", data);

   if (data.status === 200 || data.status === 201) {

  console.log("Updated category from API:", data.data);

  // ⭐ UPDATE selected category state
  setSelectedProductcategory(data.data);

  setPopupType('200or201');
  setPopupMessage('Attributes assigned to Category successfully');
  setShowPopup(true);

  setShowAssignCategoryAttributesPopup(false);
  setAttributeIds([]);

  setTimeout(() => {
    setShowPopup(false);
  }, 3000);
}


  } catch (error) {
    console.error("Error assigning attributes:", error);
  } finally {
    setIsSaving(false);
  }
};

const handleAssignClick = (subcategory) => {
  console.log("🔥 1. handleAssignClick START - Subcategory:", subcategory.product_sub_category_name);
  
  setSelectedSubcategory(subcategory);
  
  if (subcategory.attribute_value_ids) {
    const assignedAttributes = subcategory.attribute_value_ids.map(id => ({
      attribute_value_id: id
    }));
    setAttributeIds(assignedAttributes);
    console.log("🔥 2. Set attributeIds:", assignedAttributes.length, "items");
  } else {
    setAttributeIds([]);
    console.log("🔥 2. Cleared attributeIds (no existing)");
  }

  setShowAssignAttributesPopup(true);
  console.log("🔥 3. Popup opened - BEFORE fetch");

  fetchAllAttributesBySubcategory(selectedProductCategory._id, subcategory._id);
};

  const BackToLoginPage = () => {
  setShowPopup(false);
  localStorage.removeItem('LoginData');
  sessionStorage.removeItem('userData');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('userId');
  sessionStorage.removeItem('appId');
navigate('/bb');
  };

  if (isLoading) {
    return <Loader />;
  }


  const categoriesToDisplay = roleId === 6 
  ? productCategories.filter(category => (category.product_category_name.toLowerCase()) === 'tiles')
  : productCategories;

  
  const handleEditProductCategory = (selectedProductCategory) => { 
  navigate('/bb/app/items/editproductcategory', { 
    state: { 
      ProductCategoryData: {   
        _id: selectedProductCategory._id,
        product_category_name: selectedProductCategory.product_category_name,
        product_category_description: selectedProductCategory.product_category_description,
        is_ecommerce: selectedProductCategory.is_ecommerce, 
        listing_priority: selectedProductCategory.listing_priority,
        product_category_image: selectedProductCategory.product_category_image,
        isQuickQuote: selectedProductCategory.is_quick_quote,
      isProjectQuote: selectedProductCategory.is_project_quote,
        is_delivered_by_brickbucket: selectedProductCategory.is_delivered_by_brickbucket,
        is_COD_available: selectedProductCategory.is_COD_available,


        UOM_id: {
          _id: selectedProductCategory.UOM_id,
          UOM: allUOMs.find(uom => uom._id === selectedProductCategory.UOM_id)?.UOM || ''
        },
        product_sub_categories: productSubcategories.map(subCat => ({
          _id: subCat._id,
          product_sub_category_name: subCat.product_sub_category_name,
          product_sub_category_description: subCat.product_sub_category_description,
          product_sub_category_image: subCat.product_sub_category_image,
          uom: subCat.uom,
          UOM_id: subCat.UOM_id,
          default_vendor_id :  subCat.default_vendor_id,
        }))        
      }
    }
  });
};

const normalizeFaqKey = (faq) => {
  const answerText = Array.isArray(faq?.answer)
    ? faq.answer.map((item) => item.text).join('|')
    : '';
  return `${faq?.question || ''}||${answerText}`.trim();
};

const getMatchedCategoryFaqIds = (assignedFaqs) => {
  const assignedKeys = assignedFaqs.map(normalizeFaqKey);
  return categoryFaqs.reduce((ids, faq, index) => {
    if (assignedKeys.includes(normalizeFaqKey(faq))) {
      ids.push(`categoryFaq_${index}`);
    }
    return ids;
  }, []);
};

const saveCategoryFaqs = async (faqsToSave) => {
  if (!selectedProductCategory?._id) {
    setFaqError('No product category selected.');
    return false;
  }

  setFaqLoading(true);
  setFaqError('');

  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const response = await fetch(
      `${backendApiUrl}product-sub-category/create-or-update-faqs-by-productCategory`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify({
          product_category_id: selectedProductCategory._id,
          faqs: faqsToSave,
        }),
      }
    );
    const data = await response.json();
    await getResponseHandling(response, data);
    setPopupType('200or201');
    setPopupMessage('Category FAQs saved successfully.');
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 1000);
    await fetchCategoryFaqs(selectedProductCategory._id);
    return true;
  } catch (error) {
    console.error('Failed to save category FAQs:', error);
    setFaqError(error.message || 'Unable to save category FAQs.');
    return false;
  } finally {
    setFaqLoading(false);
  }
};

const assignFaqsToSubcategoryWithFaqs = async (faqList) => {
  if (!selectedProductCategory?._id || !selectedFaqSubcategory?._id) {
    setFaqError('Please select a subcategory first.');
    return false;
  }

  setFaqLoading(true);
  setFaqError('');

  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const response = await fetch(
      `${backendApiUrl}product-sub-category/assign-faqs-to-productSubCategory`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify({
          product_category_id: selectedProductCategory._id,
          product_sub_category_id: selectedFaqSubcategory._id,
          faqs: faqList,
        }),
      }
    );
    const data = await response.json();
    await getResponseHandling(response, data);
    setPopupType('200or201');
    setPopupMessage('FAQs assigned to subcategory successfully.');
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 1000);
    setSubcategoryFaqs(faqList);
    return true;
  } catch (error) {
    console.error('Failed to assign FAQs:', error);
    setFaqError(error.message || 'Unable to assign FAQs to subcategory.');
    return false;
  } finally {
    setFaqLoading(false);
  }
};

const fetchCategoryFaqs = async (productCategoryId) => {
  if (!productCategoryId) return;
  setFaqLoading(true);
  setFaqError('');
  setCategoryFaqs([]);

  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const response = await fetch(
      `${backendApiUrl}product-sub-category/get-faqs-by-productCategoryId?product_category_id=${productCategoryId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );
    const data = await response.json();
    console.log('Fetch category FAQs response:', data);
    const output = await getResponseHandling(response, data);
    const faqDoc = Array.isArray(output) ? output[0] : output;
    setCategoryFaqs(faqDoc?.faqs || []);
    return faqDoc?.faqs || [];
  } catch (error) {
    console.error('Failed to fetch category FAQs:', error);
    setFaqError(error.message || 'Unable to load category FAQs.');
    return [];
  } finally {
    setFaqLoading(false);
  }
};

const fetchSubcategoryFaqs = async (subcategoryId) => {
  if (!subcategoryId) {
    setSubcategoryFaqs([]);
    return [];
  }

  setFaqLoading(true);
  setFaqError('');
  setSubcategoryFaqs([]);

  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const response = await fetch(
      `${backendApiUrl}product-sub-category/get-faqs-by-productSubCategoryId?product_sub_category_id=${subcategoryId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );
    const data = await response.json();
    console.log('Fetch subcategory FAQs response:', data);
    const output = await getResponseHandling(response, data);
    const faqDoc = Array.isArray(output) ? output[0] : output;
    const faqs = faqDoc?.faqs || [];
    setSubcategoryFaqs(faqs);
    return faqs;
  } catch (error) {
    console.error('Failed to fetch subcategory FAQs:', error);
    setFaqError(error.message || 'Unable to load subcategory FAQs.');
    return [];
  } finally {
    setFaqLoading(false);
  }
};

const handleFaqSubcategoryChange = async (subcategoryId) => {
  const subcategory = productSubcategories.find((sub) => sub._id === subcategoryId);
  setSelectedFaqSubcategory(subcategory);
  setSelectedCategoryFaqIds([]);

  if (subcategory) {
    const assignedFaqs = await fetchSubcategoryFaqs(subcategory._id);
    if (assignedFaqs.length > 0) {
      setSelectedCategoryFaqIds(getMatchedCategoryFaqIds(assignedFaqs));
    }
  } else {
    setSubcategoryFaqs([]);
  }
};

const handleCategoryFaqToggle = (faqIndex) => {
  const itemId = `categoryFaq_${faqIndex}`;
  setSelectedCategoryFaqIds((prev) =>
    prev.includes(itemId) ? prev.filter((id) => id !== itemId) : [...prev, itemId]
  );
};

const handleAddCategoryFaq = () => {
  if (!newFaqQuestion.trim() || !newFaqAnswer.trim()) {
    setFaqError('Please enter both question and answer.');
    return;
  }
  const structuredAnswer = convertToStructuredAnswer(newFaqAnswer);

  setCategoryFaqs((prev) => [
    ...prev,
    {
      question: newFaqQuestion.trim(),
     answer: structuredAnswer,
    },
  ]);
  setNewFaqQuestion('');
  setNewFaqAnswer('');
  setFaqError('');
};



const handleSaveCategoryFaqs = async () => {
  await saveCategoryFaqs(categoryFaqs);
};

const handleAssignFaqsToSubcategory = async () => {
  if (!selectedFaqSubcategory?._id) {
    setFaqError('Please select a subcategory first.');
    return;
  }

  const selectedFaqs = selectedCategoryFaqIds
    .map((itemId) => {
      const index = parseInt(itemId.replace('categoryFaq_', ''), 10);
      return categoryFaqs[index];
    })
    .filter(Boolean);

  if (selectedFaqs.length === 0) {
    setFaqError('Select one or more category FAQs to assign to the subcategory.');
    return;
  }

  const success = await assignFaqsToSubcategoryWithFaqs(selectedFaqs);
  if (success) {
    setSelectedCategoryFaqIds(getMatchedCategoryFaqIds(selectedFaqs));
  }
};

// const handleDeleteSubcategoryFaq = async (faq) => {
//   console.log('Attempting to delete FAQ:', faq);
//   const confirmed = window.confirm('Remove this FAQ?');
//   if (!confirmed) return;

//   try {
//     setFaqLoading(true);

//     const encryptedToken = sessionStorage.getItem('token');
//     const token = decryptData(encryptedToken);

//     const response = await fetch(
//       `${backendApiUrl}product-sub-category/delete-faq-by-id?faq_id=${faq._id}`,
//       {
//         method: 'DELETE',
//         headers: {
//           'Content-Type': 'application/json',
//           'x-token': token,
//         },
//       }
//     );

//     const data = await response.json();
//     console.log('Delete FAQ response:', data);
//     await getResponseHandling(response, data);

//     if (response.status === 200) {
//       setSubcategoryFaqs((prev) =>
//         prev.filter((item) => item._id !== faq._id)
//       );

//       setPopupType('200or201');
//       setPopupMessage('FAQ removed successfully');
//       setShowPopup(true);
//     }

//   } catch (error) {
//     console.error('Delete subcategory FAQ error:', error);
//   } finally {
//     setFaqLoading(false);
//   }
// };

const handleDeleteSubcategoryFaqConfirm = async () => {
  if (!faqToDelete) return;
  
  console.log('Deleting FAQ:', faqToDelete);
  try {
    setFaqLoading(true);
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    console.log("token for deletion:", token);

    // ✅ FIXED: Use the CORRECT endpoint from your backend logs
    const response = await fetch(
      `${backendApiUrl}product-sub-category/delete-faq-by-id?faq_id=${faqToDelete._id}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      }
    );

    const data = await response.json();
    console.log('Delete FAQ response:', data);
    
    if (response.status === 200 || data.status === 200) {
      // Update both FAQ lists immediately
      setCategoryFaqs((prev) => prev.filter((item) => item._id !== faqToDelete._id));
      setSubcategoryFaqs((prev) => prev.filter((item) => item._id !== faqToDelete._id));

      
      // Clear selected FAQs
      setSelectedCategoryFaqIds([]);
      
      setPopupType('200or201');
      setPopupMessage('FAQ removed successfully');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 1000);
    } else {
      setFaqError(data.message || 'Failed to delete FAQ');
    }
  } catch (error) {
    console.error('Delete error:', error);
    setFaqError('Failed to delete FAQ');
  } finally {
    setFaqLoading(false);
    setShowDeleteConfirm(false);
    setFaqToDelete(null);
  }
};

const handleDeleteSubcategoryFaq = (faq) => {
  console.log('🔥 FAQ delete requested - FAQ object:', faq);
  console.log('🔥 FAQ _id:', faq._id); // ✅ Verify this is the correct FAQ _id
  console.log('🔥 Full FAQ structure:', JSON.stringify(faq, null, 2));
  
  setFaqToDelete(faq);
  setShowDeleteConfirm(true);
};

const handleRemoveAssignedFaq = async (faqToRemove) => {
    // 🔥 NEW: confirmation
  if (!window.confirm("Unassign this FAQ?")) return;

  setLoadingFaqId(faqToRemove._id); // 👈 NEW loader
  try {
    const encryptedToken = sessionStorage.getItem("token");
    const token = decryptData(encryptedToken);

    const response = await fetch(
      `${backendApiUrl}product-sub-category/delete-faq-by-id?faq_id=${faqToRemove._id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    if (response.ok) {
      setSubcategoryFaqs((prev) =>
        prev.filter((faq) => faq._id !== faqToRemove._id)
      );
    } else {
      console.error("Failed to delete FAQ");
    }

  } catch (err) {
    console.error(err);
  }finally {
    setLoadingFaqId(null); // 👈 stop loader
  }
};

const convertToStructuredAnswer = (text) => {
  const parts = [];

const regex = /\[(highlight|danger|bold|underline|li|ol)\](.*?)\[\/\1\]|\[color:(.*?)\](.*?)\[\/color\]|\[size:(.*?)\](.*?)\[\/size\]|\[br\]/g;  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
  if (match.index > lastIndex) {
    parts.push({ text: text.substring(lastIndex, match.index) });
  }

  if (match[0] === "[br]") {
    parts.push({ style: "br" });
  } 
  else if (match[3]) {
    // color
    parts.push({
      text: match[4],
      style: "color",
      value: match[3]
    });
  } 
  else if (match[5]) {
    // size
    parts.push({
      text: match[6],
      style: "size",
      value: match[5]
    });
  } 
  else {
    parts.push({
      text: match[2],
      style: match[1]
    });
  }

  lastIndex = regex.lastIndex;
}

  if (lastIndex < text.length) {
    parts.push({ text: text.substring(lastIndex) });
  }

  return parts;
}; 


const renderFormattedAnswer = (answerArray) => {

  // 🔥 NEW: safety check
  if (!answerArray || answerArray.length === 0) return null;

  return answerArray.map((item, index) => (

    // 🔥 CHANGE: render HTML properly
    <div
      key={index}
      dangerouslySetInnerHTML={{ __html: item.text }} // 👈 THIS FIXES <ul>, <li>, etc.
    />

  ));
};

const handleCloseFaqPopup = () => {
  setShowFaqPopup(false);
  setSelectedFaqSubcategory(null);
  setCategoryFaqs([]);
  setSubcategoryFaqs([]);
  setSelectedCategoryFaqIds([]);
  setNewFaqQuestion('');
  setNewFaqAnswer('');
  setFaqError('');
};

const handleFAQPopup = async (productCategory) => {
  setFaqError('');
  setSelectedCategoryFaqIds([]);
  setNewFaqQuestion('');
  setNewFaqAnswer('');
  setShowFaqPopup(true);

  const categoryId = productCategory?._id || selectedProductCategory?._id;
  await fetchCategoryFaqs(categoryId);

  if (productSubcategories.length > 0) {
    const firstSubcategory = productSubcategories[0];
    setSelectedFaqSubcategory(firstSubcategory);
    await fetchSubcategoryFaqs(firstSubcategory._id);
  } else {
    setSelectedFaqSubcategory(null);
    setSubcategoryFaqs([]);
  }
};


    return (

    <div className=" bg-white flex flex-row w-full justify-center overflow-y-hidden">
      {/* List of Customers Div start */}
      <div className=" flex flex-col  w-[32%]  ">
  <div className="p-4 border-b  flex flex-row justify-between ">
    <div>
    <h5 className="text-md font-semibold cursor-pointer ">All Item Categories
     <FontAwesomeIcon icon={faChevronDown} className="text-xs mb-0.5 text-blue-600 mx-1 cursor-pointer " />
    </h5>
    </div>
    <div className=''>
    <button 
  className="mr-2 bg-[#f7525a] text-white px-1 py-0.5 rounded-md" 
  title="" data-tooltip="Create Item Category"  style={{ '--tooltip-bg': 'black' }}
  onClick={handleCreateProductCategory}>
  <FontAwesomeIcon icon={faPlus}  className="mb-0.5 text-xs text-white mx-1 cursor-pointer" />
</button>
</div>
  </div>
  <div className=" flex justify-center  overflow-y-hidden  flex-col ">
   <div className='flex  flex-col h-[80vh]  overflow-y-auto '
    ref={listContainerRef}>
   {categoriesToDisplay.map((productcategory) => (
        <div
          key={productcategory._id}
           ref={(el) => (itemRefs.current[productcategory._id] = el)}
          onClick={() => handleProductCategoryClick(productcategory)}
          className={`border-b text-sm flex items-center px-4 py-2 ${selectedProductCategory?._id === productcategory._id ? 'bg-gray-100' : ''} hover:bg-gray-100 cursor-pointer`}
        >
          <div className='flex flex-row'>
            <div>
<input
  type="checkbox"
  className="mr-3 w-3 h-3 accent-blue-600 cursor-pointer"
/>
            </div>
            <div className='flex flex-col'>
              <p className='text-md font-semibold' >{productcategory.product_category_name}</p>
            </div>
          </div>
        </div>
      ))}
  </div>
</div>
</div>
    <div className="border-l w-full flex flex-col">
      {categoriesToDisplay.length > 0 ? (
        selectedProductCategory ? (
          <>
            <div className="border-b h-24">
              <div className='p-6 flex justify-between items-center'>
                <span className="text-md font-semibold">{selectedProductCategory?.product_category_name}</span>
                <div className="flex items-center gap-2">
                  <div className="relative" ref={assignDropdownRef}>
{/*   <button
    className="bg-gray-100 text-sm px-2 py-1 shadow-sm border rounded-md mr-2"
    onClick={handleOpenAssign}
  >
    Assign
  </button> */}

  {assignType && (
    <div className="absolute left-1/2 transform -translate-x-1/2 mt-2 w-28  rounded-md shadow-lg z-[999]">

      <div
        className="py-1 px-2 hover:bg-[#f7525a] hover:text-white cursor-pointer"
        onClick={() => handleAssignTypeSelect("attributes")}
      >
        Attributes
      </div>

    </div>
  )}
</div>

                 <button className="bg-gray-100 px-2 py-1 shadow-sm text-sm border rounded-md mr-2" 

                    onClick={() => handleFAQPopup(selectedProductCategory)}
                  >
                    FAQ's
                   </button>
                 <button className="bg-gray-100 px-2 py-1 shadow-sm text-sm border rounded-md mr-2" 

                    onClick={() => handleEditProductCategory(selectedProductCategory)}
                  >
                    Edit
                   </button>

                   <button className=" text-white px-1 py-1 rounded-md "
        title="" data-tooltip="Close"  style={{ '--tooltip-bg': 'black' }}>   
        <FontAwesomeIcon icon={faX} onClick={handleClose} className="text-md text-[#f7525a] mx-2 cursor-pointer " />
      </button>
                </div>
              </div>
            </div>
        {ProductCategoryLoader ? (
    <Loader />
  ) : (
        <div className="flex h-5/6 w-full justify-center flex-row mt-4">
        {productSubcategories.length > 0 ? (
               <div className="w-[80%] max-h-[80vh] overflow-y-auto">
      <table className="w-full border-collapse border border-gray-200 mb-8">
             <thead className="sticky top-0 bg-[#fafafc] z-10">
              <tr className="text-[#212529] bg-[#fafafc]">
               <th className="font-semibold text-xs py-2 px-4 border-b cursor-pointer">SubCategory Image</th>

                {/* <th className="font-semibold text-xs py-2 px-4 border-b cursor-pointer">Item Category Name</th> */}
                
                <th className="font-semibold text-xs py-2 px-4 border-b cursor-pointer">Subcategory</th>
                <th className="font-semibold text-xs py-2 px-4 border-b cursor-pointer">UOM</th>
                <th className="font-semibold text-xs py-2 px-4 border-b cursor-pointer">Description</th>
                  <th className="font-semibold text-xs py-2 px-4 border-b">Attributes</th>
              </tr>
            </thead>
              <tbody className="h-20 overflow-y-auto">
                {productSubcategories.map((subcategory) => (
                  <tr key={subcategory._id} className='text-xs  border-b'>
                    {/* <td  className='py-2 px-4 text-center text-blue-600 '>
                      {selectedProductCategory?.product_category_name}
                    </td> */}

                     <td className="py-2 text-center px-4">
                  {subcategory?.product_sub_category_image ? (
  <img
    src={`${imageUrl}${subcategory.product_sub_category_image}`}
    alt={subcategory.product_sub_category_name}
    className="w-12 h-12 object-cover mx-auto rounded border border-gray-300"
  />
) : (
  <div className="w-12 h-12 flex flex-col items-center justify-center border border-gray-300 rounded text-gray-400 text-[10px] mx-auto">
    <span>No</span>
    <span>Image</span>
  </div>
)}

                    </td>
                    <td className="py-2 text-center px-4">{subcategory.product_sub_category_name}</td>
                   
                    <td className="py-2 text-center px-4">{subcategory.uom}</td>
                    <td className="py-2 text-center px-4">{subcategory.product_sub_category_description}</td>
                <td className="py-2 px-4 text-center">
                 <button
                 className="bg-blue-500 text-white px-2 py-1 rounded text-xs"
                   onClick={() => handleAssignClick(subcategory)}
                   >
                 Assign
                </button>

                   </td>

                  </tr>
                ))}
              </tbody>
          </table>
          </div>
        ) : (
          <div className='flex justify-center items-center w-full'>
            <p className='text-center'>No Item Subcategories Available</p>
          </div>
        )}
        </div>
  )}
      </>
    ) : (
      <div className="flex justify-center items-center h-full">
        <p className="text-gray-500">Select a Item Category to view details</p>
      </div>
    )
  ) : (
    <div className="flex justify-center items-center h-full">
      <p className="text-gray-500">No Item Categories Available</p>
    </div>
  )}
</div>
{showPopup && (
        <div className='z-[9999]'>
          {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
          {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
          {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
        </div>
      )}

     {showAssignAttributesPopup && (
  <div className="fixed z-20 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-b-md shadow-md w-1/2 h-[70vh] flex flex-col ">

      {/* HEADER */}
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md">Attributes</h2>

        <button onClick={handleCloseAttributePopup} className="text-white px-1 py-1 rounded-md">
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer" />
        </button>
      </div>

      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />

      {attributeLoading ? (
        <Loader />
      ) : (
        <>
           <div className="flex-1 overflow-y-auto w-full flex flex-col items-center px-6 py-4 space-y-4">   

            {/* ERROR MESSAGE */}
            {Object.keys(errors).length > 0 && (
              <div className="flex justify-between w-full p-2 items-center px-auto py-3 bg-[#fddcde] rounded-md">

                <div className="px-6 flex flex-col space-y-2 justify-start items-start">
                  {errors.assign_attribute && (
                    <span className="text-sm">• {errors.assign_attribute}</span>
                  )}
                </div>

                <div className='px-4'>
                  <button
                    className="text-gray-700 hover:text-red-500"
                    onClick={() => setErrors({})}
                  >
                    <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                  </button>
                </div>

              </div>
            )}

            {/* ATTRIBUTES TABLE */}
            <div className="flex justify-center flex-col items-center">

              {subcategoryAttributes.length > 0 ? (

                <table>
                  <tbody>

                   {subcategoryAttributes.map((attribute) => (

                      <tr key={attribute.attribute_name_id} className='border-2 border-opacity-50'>

                        <td className='py-2 px-4 border-2 border-opacity-50'>
                          <h1 className='font-semibold'>
                            {attribute.attribute_name}
                          </h1>
                        </td>

                        <td>

                          <div className='flex flex-col text-sm items-left ml-10 px-4 py-2'>

                           {attribute.attribute_values.map((attributeValue, attributeValueIndex) => (
  <div key={attributeValue.attribute_value_id} className='flex flex-row items-center'>
    <input
      type='checkbox'
      id={`attribute_${attribute.attribute_name_id}_${attributeValue.attribute_value_id}`}  // ✅ Use stable IDs
      name={`attribute_${attribute.attribute_name_id}`}
                                 onChange={() =>
                                    handleCheckboxChange(
                                      attribute.attribute_name_id,
                                       attributeValue.attribute_value_id
                                       )
                                      }
                                  checked={attributeIds.some(
                                    id =>
                                      id.attribute_value_id ===
                                      attributeValue.attribute_value_id
                                  )}
  className="w-4 h-4 border-gray-400 accent-red-600 cursor-pointer"
                                />

                               <label
  htmlFor={`attribute_${attribute.attribute_name_id}_${attributeValue.attribute_value_id}`}
  className='ml-5'
>
  {attributeValue.attribute_value}
</label>
                              </div>

                            ))}

                          </div>

                        </td>

                      </tr>

                    ))}

                  </tbody>
                </table>

              ) : (

                <div className="flex justify-center items-center h-64 w-full">
                  <span className="text-gray-500 text-sm">
                    No attributes available.
                  </span>
                </div>

              )}

            </div>

          </div>

          {/* FOOTER */}
          <div className="mt-auto w-full">

            <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />

            <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">

              <button
                className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md space-x-2 flex items-center"
                onClick={handleAddattributesToSubCategory}
              >
                <span>Save</span>
                {isSaving && (<Spinner />)}
              </button>

              <button
                onClick={handleCloseAttributePopup}
                className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
                  isSaving
                    ? 'bg-gray-400 text-gray-500 cursor-not-allowed'
                    : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
                }`}
                disabled={isSaving}
              >
                Cancel
              </button>

            </div>

          </div>
        </>
      )}

    </div>
  </div>
)}

 {showAssignCategoryAttributesPopup && (
  <div className="fixed z-20 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
<div className="bg-white rounded-b-md shadow-md w-1/2 h-[70vh] flex flex-col">

      {/* HEADER */}
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md">Attributes</h2>

        <button onClick={handleCloseCategoryAttributePopup} className="text-white px-1 py-1 rounded-md">
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer" />
        </button>
      </div>

      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />

      {attributeLoading ? (
        <Loader />
      ) : (
        <>
           <div className="flex-1 overflow-y-auto w-full flex flex-col items-center px-6 py-4 space-y-4">   

            {/* ERROR MESSAGE */}
            {Object.keys(errors).length > 0 && (
              <div className="flex justify-between w-full p-2 items-center px-auto py-3 bg-[#fddcde] rounded-md">

                <div className="px-6 flex flex-col space-y-2 justify-start items-start">
                  {errors.assign_attribute && (
                    <span className="text-sm">• {errors.assign_attribute}</span>
                  )}
                </div>

                <div className='px-4'>
                  <button
                    className="text-gray-700 hover:text-red-500"
                    onClick={() => setErrors({})}
                  >
                    <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                  </button>
                </div>

              </div>
            )}

            {/* ATTRIBUTES TABLE */}
            <div className="flex justify-center flex-col items-center">

              {categoryAttributes.length > 0 ? (

                <table>
                  <tbody>

                 {categoryAttributes.map((attribute) => (
  <tr key={attribute.attribute_name_id} className='border-2 border-opacity-50'>

                        <td className='py-2 px-4 border-2 border-opacity-50'>
                          <h1 className='font-semibold'>
                            {attribute.attribute_name}
                          </h1>
                        </td>

                        <td>

                          <div className='flex flex-col text-sm items-left ml-10 px-4 py-2'>

                           {attribute.attribute_values.map((attributeValue, attributeValueIndex) => (
  <div key={attributeValue.attribute_value_id} className='flex flex-row items-center'>
    <input
      type='checkbox'
      id={`attribute_${attribute.attribute_name_id}_${attributeValue.attribute_value_id}`}  // ✅ Use stable IDs
      name={`attribute_${attribute.attribute_name_id}`}
                                  onChange={() =>
                                    handleCheckboxChangeCategory(
                                      attribute.attribute_name_id,
                                      attributeValue.attribute_value_id
                                    )
                                  }
                                 checked={attributeIds.some(id => {
  console.log("Comparing:", id.attribute_value_id, attributeValue.attribute_value_id);
  return id.attribute_value_id === attributeValue.attribute_value_id;
})}
  className="w-4 h-4 border-gray-400 accent-red-600 cursor-pointer"
                                />

                               <label
  htmlFor={`attribute_${attribute.attribute_name_id}_${attributeValue.attribute_value_id}`}
  className='ml-5'
>
  {attributeValue.attribute_value}
</label>

                              </div>

                            ))}

                          </div>

                        </td>

                      </tr>

                    ))}

                  </tbody>
                </table>

              ) : (

                <div className="flex justify-center items-center h-64 w-full">
                  <span className="text-gray-500 text-sm">
                    No attributes available.
                  </span>
                </div>

              )}

            </div>

          </div>

          {/* FOOTER */}
          <div className="mt-auto w-full">

            <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />

            <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">

              <button
                className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md space-x-2 flex items-center"
                onClick={handleAddattributesToCategory}
              >
                <span>Save</span>
                {isSaving && (<Spinner />)}
              </button>

              <button
                onClick={handleCloseCategoryAttributePopup}
                className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
                  isSaving
                    ? 'bg-gray-400 text-gray-500 cursor-not-allowed'
                    : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
                }`}
                disabled={isSaving}
              >
                Cancel
              </button>

            </div>

          </div>
        </>
      )}

    </div>
  </div>
)}

{showFaqPopup && (
  <div className="fixed inset-0 z-30 flex items-top justify-center bg-black bg-opacity-50 p-1 overflow-auto">
    <div className="bg-white rounded-md shadow-xl w-full max-w-6xl xl-max-w-7xl max-h-[92vh] xl-max-h-[96vh] overflow-hidden flex flex-col">
      <div className="flex items-center justify-between px-6 py-4 bg-[#F9F9FB] border-b">
        <div>
          <h2 className="text-lg font-semibold">FAQ management</h2>
          <p className="text-sm text-gray-600">
            FAQs for{" "}
            {categoryImage && (
              <img
                src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + categoryImage}
                alt={categoryName}
                className="w-8 h-8 rounded-full object-cover inline-block mx-1"
              />
            )}
            <span className="font-semibold">{categoryName}</span>. 
            {" "}Select a subcategory to view and manage FAQs assigned to it.
          </p>
        </div>
        <button onClick={handleCloseFaqPopup} className="text-gray-700 hover:text-red-600">
          <FontAwesomeIcon icon={faX} />
        </button>
      </div>

<div className="flex flex-col lg:flex-row flex-1 overflow-hidden">

  {/* LEFT: FAQ CREATION + LIST */}
  <div className="lg:w-2/3 p-4 overflow-y-auto space-y-6 bg-gray-50">

    {/* Add FAQ */}
    <div className="rounded-md border bg-white border-gray-200 p-4 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-900 mb-3">
        Add FAQ
      </h3>

      <div className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-gray-700">Question</label>
          <input
            type="text"
            value={newFaqQuestion}
            onChange={(e) => setNewFaqQuestion(e.target.value)}
            className="mt-2 w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Answer</label>
          <textarea
            value={newFaqAnswer}
            onChange={(e) => setNewFaqAnswer(e.target.value)}
            rows={4}
            className="mt-2 w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
          />
        </div>

        <button
          type="button"
          onClick={handleAddCategoryFaq}
          className="rounded-md bg-[#f7525a] px-4 py-2 text-sm font-medium text-white hover:bg-[#d8404e]"
        >
          Add FAQ
        </button>
      </div>
    </div>

    {/* FAQ LIST */}
    <div className="rounded-md border bg-white border-gray-200 p-4 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-900">
          FAQ List
        </h3>

        <button
          type="button"
          onClick={handleSaveCategoryFaqs}
          className="rounded-md bg-[#f7525a] px-3 py-2 text-xs font-medium text-white hover:bg-[#d8404e]"
        >
          Save All
        </button>
      </div>

      {categoryFaqs.length > 0 ? (
        <div className="space-y-3">
          {categoryFaqs.map((faq, faqIndex) => {
            const itemId = `categoryFaq_${faqIndex}`;
            return (
              <div key={itemId} className="rounded-md border border-gray-100 p-3 hover:bg-gray-50 transition">
                <div className="flex items-start justify-between gap-3">

                  <label className="flex-1 cursor-pointer">
                    <div className="flex items-start gap-2">
                      <input
                        type="checkbox"
                        checked={selectedCategoryFaqIds.includes(itemId)}
                        onChange={() => handleCategoryFaqToggle(faqIndex)}
                        className="mt-1 h-4 w-4 rounded border-gray-300 text-[#f7525a]"
                      />

                      <div>
                        <div className="font-medium text-sm text-gray-900">
                          {faq.question}
                        </div>

                        <div className="mt-1 text-sm text-gray-600">
                          {renderFormattedAnswer(faq.answer)}
                        </div>
                      </div>
                    </div>
                  </label>

                  <button
                    type="button"
                    onClick={() => handleDeleteSubcategoryFaq(faq)}
                    className="text-sm text-red-600 hover:text-red-800"
                  >
                    Delete
                  </button>

                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-sm text-gray-500">
          No FAQs yet.
        </div>
      )}
    </div>

  </div>

  {/* RIGHT: ASSIGNMENT PANEL */}
  <div className="lg:w-1/3 border-l bg-white border-gray-200 p-4 overflow-y-auto">

    <h3 className="text-sm font-semibold text-gray-900 mb-4">
      Assign FAQs to Sub Category
    </h3>

    <label className="block text-sm font-medium text-gray-700">
      Select Sub Category
    </label>

    <select
      value={selectedFaqSubcategory?._id || ''}
      onChange={(e) => handleFaqSubcategoryChange(e.target.value)}
      className="mt-2 w-full border rounded-md px-3 py-2 text-sm"
    >
      <option value="">Select subcategory</option>
      {productSubcategories.map((sub) => (
        <option key={sub._id} value={sub._id}>
          {sub.product_sub_category_name}
        </option>
      ))}
    </select>

    {/* INFO PANEL */}
    <div className="mt-6 bg-gray-50 border rounded-md p-3 text-sm space-y-2">
      <p>Selected: <span className="font-medium">{selectedFaqSubcategory?.product_sub_category_name || 'None'}</span></p>
      <p>Selected FAQs: <span className="font-medium">{selectedCategoryFaqIds.length}</span></p>
      <p>Already Assigned: <span className="font-medium">{subcategoryFaqs.length}</span></p>
    </div>

    <button
      type="button"
      onClick={handleAssignFaqsToSubcategory}
      className="mt-4 w-full rounded-md bg-[#f7525a] px-4 py-2 text-sm font-medium text-white hover:bg-[#d8404e]"
    >
      Assign FAQs
    </button>

    {/* ASSIGNED FAQS */}
    <div className="mt-6">
      <h4 className="text-sm font-semibold mb-2">Assigned FAQs</h4>

      {subcategoryFaqs.length > 0 ? (
        <div className="space-y-2">
          {subcategoryFaqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-md p-2 text-sm flex justify-between gap-2"
            >
              <div>
                <div className="font-medium">{faq.question}</div>
                <div className="text-gray-600">
                  {renderFormattedAnswer(faq.answer)}
                </div>
              </div>

              <button
                type="button"
                onClick={() => handleRemoveAssignedFaq(faq)}
                disabled={loadingFaqId === faq._id}
                className="text-red-600 text-xs hover:text-red-800"
              >
              {loadingFaqId === faq._id
                ? "Removing..."   // 👈 loader text
                : "Unassign"}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500">
          No FAQs assigned yet.
        </p>
      )}
    </div>

  </div>

</div>

      <div className="flex justify-end gap-2 border-t border-gray-200 bg-[#F9F9FB] p-4">
        <button
          type="button"
          onClick={handleCloseFaqPopup}
          className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}


 {showDeleteConfirm && (
  <div className="fixed inset-0 z-40 flex items-top justify-center bg-black bg-opacity-50 p-2">
    <div className="bg-white rounded-lg shadow-xl max-w-sm w-full max-h-[140px] border border-gray-200">
      {/* Header */}
      <div className="p-4">
        <div className="flex items-start gap-3">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Delete FAQ</h3>
            <p className="text-sm text-gray-600 mt-1">
              Are you sure you want to delete this FAQ?
            </p>
          
          </div>
        </div>
      </div>
      
      {/* Buttons */}
      <div className="p-2 rounded-b-lg">
        <div className="flex gap-3 justify-end">
          <button
            onClick={() => {
              setShowDeleteConfirm(false);
              setFaqToDelete(null);
            }}
            className="px-4 py-1 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 border border-gray-200 rounded-lg transition-all duration-200"
            disabled={faqLoading}
          >
            Cancel
          </button>
          <button
            onClick={handleDeleteSubcategoryFaqConfirm}
            disabled={faqLoading}
            className="px-4 py-1 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 disabled:bg-red-400 disabled:cursor-not-allowed rounded-lg transition-all duration-200 flex items-center gap-2 min-w-[100px] justify-center"
          >
            {faqLoading ? (
              <>
                <Spinner size="sm" />
                Deleting
              </>
            ) : (
              'Delete'
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    </div>

  );
};



export default ViewProductCategory;